import React, { Component } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import { ReduxState } from '../server';
import { Page } from '../page';

import { Spinner } from 'react-bootstrap';
import { SocketSingleton } from '../helpers/socket_singleton';


const NavMenu = loadable(() => import('./nav_menu'), { fallback: <Spinner animation='border' />});
const ReportPage = loadable(() => import('../pages/report/report_viewer'), { fallback: <Spinner animation='border' />});
const HomePage = loadable(() => import('../pages/home'), { fallback: <Spinner animation='border' />});
const RequestsPage = loadable(() => import('../pages/requests'), { fallback: <Spinner animation='border' />});
const AboutPage = loadable(() => import('../pages/about'), { fallback: <Spinner animation='border' />});

export interface AppState extends ReduxState {
	reportUrlCopied?: boolean;
	socketSingleton: SocketSingleton;
}

class App extends Component<any, AppState> {
	public reportUrlCopiedTimeout = 1500;
	constructor(props: any) {
		super(props);
	}
	public componentDidMount() {
		const socketSingleton = SocketSingleton.getInstance();
		this.setState({ socketSingleton });
		socketSingleton.initializeSocket(this.props.serverUrl);
	}
	public componentWillUnmount() {
		const { socketSingleton } = this.state;
		if (socketSingleton && socketSingleton.isSocketConnected()) {
			socketSingleton.getSocket().disconnect();
		}
	}
	public render() {
		const { dispatch, activePage, serverUrl, reportAvailable } = this.props;
		let mainContent;
		switch (activePage) {
			case Page.REPORT: {
				mainContent = <ReportPage dispatch={dispatch} serverUrl={serverUrl}></ReportPage>;
				break;
			}
			case Page.REQUESTS: {
				mainContent = <RequestsPage dispatch={dispatch} serverUrl={serverUrl}></RequestsPage>;
				break;
			}
			case Page.ABOUT: {
				mainContent = <AboutPage></AboutPage>;
				break;
			}
			case Page.TEST_SETTINGS:
			default:
				mainContent = <HomePage dispatch={dispatch}/>;
				break;
		}
		return <div>
			<NavMenu dispatch={dispatch} serverUrl={serverUrl} reportAvailable={reportAvailable}></NavMenu>
			<div id="mainContent">{mainContent}</div>
		</div>
	}
}

function mapStateToProps(state: any) {
	const { activePage, reportAvailable, serverUrl } = state;

	return {
		activePage,
		reportAvailable,
		serverUrl
	};
}

export default connect(mapStateToProps)(App);
